import TemplateView from '../../TemplateView'
import Button from '../../components/Button'
import messageResource from '../../messageResource'

export default class AddonsMenu extends TemplateView {
    constructor({
        additionalClass = '',
        integrationComponents = [],
        addonsComponents = [],
        onUpgradeButtonClick = () => {},

    } = {}) {
        super()

        this.params = {
            additionalClass,
            integrationComponents,
            addonsComponents,
        }

        this.callbacks = {
            onUpgradeButtonClick,
        }

        this.state = {
            showUpgradeSection: false,
        }

        this.onStatePropertyChanged('showUpgradeSection', (showUpgradeSection) => {
            this.$upgradeSection.toggle(showUpgradeSection)
        })
    }

    templateHtml() {
        return `<div class='addonsMenu <%-additionalClass%>'>
                    <div class='integrations'>
                        <div class='title'><%=integrationsTitle%></div>
                        <div class='content'/>
                    </div>
                    <div class='addons'>
                        <div class='title'><%=addonsTitle%></div>
                        <div class='content'/>
                    </div>
                    <div class='upgradeSection'>
                        <div class='note'>
                            <div class='icon'/>
                            <div class='text'><%=switchToPaid%></div>
                        </div>
                        <div class='button'/>
                    </div>
                </div>`
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }

    messageKeys() {
        return {
            integrationsTitle: 'navigator.integrations_menu_title',
            addonsTitle: 'navigator.addons_menu_title',
            switchToPaid: 'menu.addons.switch_to_paid.note',
        }
    }

    afterRender() {
        const $integrationsContent = this.find('.integrations .content')
        this.params.integrationComponents.forEach(component => component.init($integrationsContent))

        const $addonsContent = this.find('.addons .content')
        this.params.addonsComponents.forEach(component => component.init($addonsContent))

        this.$upgradeSection = this.find('.upgradeSection')
        new Button({
            additionalClass: 'upgrade',
            label: messageResource.getMessage('menu.addons.switch_to_paid.button'),
            onClickCb: this.callbacks.onUpgradeButtonClick,
        }).init(this.find('.upgradeSection .button'))

        this.renderInitialState()
    }
}



// WEBPACK FOOTER //
// ./web/js/support/addons/AddonsMenu.js